import { useLockTimesheet } from "components/timesheet/lock/useLock";
import { useTimesheet } from "components/timesheet/context";

export default function Lock({ children, show = false }) {
  const { date } = useTimesheet();

  const { isDateLocked, hasUnlockData } = useLockTimesheet({
    date,
  });

  // Determine if component should render
  let shouldRender = false;
  if (show) {
    shouldRender = isDateLocked && !hasUnlockData;
  } else {
    shouldRender = !isDateLocked || hasUnlockData;
  }

  return (
    shouldRender &&
    (typeof children === "function" ? children({ date }) : children)
  );
}
